

<template>
    <div class="rests_times">
        <times :times="this.times_data"></times>
    </div>
</template>

<script>
import times from "../../../../times/times.vue";

export default {
    name: "action_schedule",
    props : {
        action : {
            type : Object
        }
    },
    components: {
        times
    },

    methods : {

    },
    computed : {
        times_data() {
            if(this.action.hasOwnProperty("times")) {
                return this.action.times;
            }

            return [];
        },
    }
}
</script>


<style scoped>

</style>
